const tanRepository = (fetch: CustomFetch) => ({
  async resend(challengeId: string) {
    await fetch(`/v1/verification/${challengeId}/resend`, { method: 'POST' })
  },
  async verify(challengeId: string, secret: string) {
    return fetch<{ status: string }>(`/v1/verification/${challengeId}/verify`, {
      method: 'POST',
      body: { secret },
    })
  },
  async cancelVerification(challengeId: string) {
    await fetch(`/v1/verification/${challengeId}`, { method: 'DELETE' })
  },
})

export default tanRepository
